import { render, staticRenderFns } from "./bindPhone.vue?vue&type=template&id=1c36cea7&scoped=true&"
import script from "./bindPhone.vue?vue&type=script&lang=js&"
export * from "./bindPhone.vue?vue&type=script&lang=js&"
import style0 from "./bindPhone.vue?vue&type=style&index=0&id=1c36cea7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c36cea7",
  null
  
)

export default component.exports